"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _hasInterface = _interopRequireDefault(require("../../../../../hasInterface"));

var _Position = _interopRequireDefault(require("../../geomgraph/Position"));

var _Coordinate = _interopRequireDefault(require("../../geom/Coordinate"));

var _Orientation = _interopRequireDefault(require("../../algorithm/Orientation"));

var _Collections = _interopRequireDefault(require("../../../../../java/util/Collections"));

var _DirectedEdge = _interopRequireDefault(require("../../geomgraph/DirectedEdge"));

var _LineSegment = _interopRequireDefault(require("../../geom/LineSegment"));

var _Comparable = _interopRequireDefault(require("../../../../../java/lang/Comparable"));

var _ArrayList = _interopRequireDefault(require("../../../../../java/util/ArrayList"));

var _List = _interopRequireDefault(require("../../../../../java/util/List"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SubgraphDepthLocater =
/*#__PURE__*/
function () {
  function SubgraphDepthLocater() {
    _classCallCheck(this, SubgraphDepthLocater);

    SubgraphDepthLocater.constructor_.apply(this, arguments);
  }

  _createClass(SubgraphDepthLocater, [{
    key: "findStabbedSegments",
    value: function findStabbedSegments() {
      if (arguments.length === 1) {
        var stabbingRayLeftPt = arguments[0];
        var stabbedSegments = new _ArrayList.default();

        for (var i = this._subgraphs.iterator(); i.hasNext();) {
          var bsg = i.next();
          var env = bsg.getEnvelope();
          if (stabbingRayLeftPt.y < env.getMinY() || stabbingRayLeftPt.y > env.getMaxY()) continue;
          this.findStabbedSegments(stabbingRayLeftPt, bsg.getDirectedEdges(), stabbedSegments);
        }

        return stabbedSegments;
      } else if (arguments.length === 3) {
        if ((0, _hasInterface.default)(arguments[2], _List.default) && arguments[0] instanceof _Coordinate.default && arguments[1] instanceof _DirectedEdge.default) {
          var _stabbingRayLeftPt = arguments[0],
              dirEdge = arguments[1],
              _stabbedSegments = arguments[2];
          var pts = dirEdge.getEdge().getCoordinates();

          for (var i = 0; i < pts.length - 1; i++) {
            this._seg.p0 = pts[i];
            this._seg.p1 = pts[i + 1];
            if (this._seg.p0.y > this._seg.p1.y) this._seg.reverse();
            var maxx = Math.max(this._seg.p0.x, this._seg.p1.x);
            if (maxx < _stabbingRayLeftPt.x) continue;
            if (this._seg.isHorizontal()) continue;
            if (_stabbingRayLeftPt.y < this._seg.p0.y || _stabbingRayLeftPt.y > this._seg.p1.y) continue;
            if (_Orientation.default.index(this._seg.p0, this._seg.p1, _stabbingRayLeftPt) === _Orientation.default.RIGHT) continue;
            var depth = dirEdge.getDepth(_Position.default.LEFT);
            if (!this._seg.p0.equals(pts[i])) depth = dirEdge.getDepth(_Position.default.RIGHT);
            var ds = new DepthSegment(this._seg, depth);

            _stabbedSegments.add(ds);
          }
        } else if ((0, _hasInterface.default)(arguments[2], _List.default) && arguments[0] instanceof _Coordinate.default && (0, _hasInterface.default)(arguments[1], _List.default)) {
          var _stabbingRayLeftPt2 = arguments[0],
              dirEdges = arguments[1],
              _stabbedSegments2 = arguments[2];

          for (var i = dirEdges.iterator(); i.hasNext();) {
            var de = i.next();
            if (!de.isForward()) continue;
            this.findStabbedSegments(_stabbingRayLeftPt2, de, _stabbedSegments2);
          }
        }
      }
    }
  }, {
    key: "getDepth",
    value: function getDepth(p) {
      var stabbedSegments = this.findStabbedSegments(p);
      if (stabbedSegments.size() === 0) return 0;

      var ds = _Collections.default.min(stabbedSegments);

      return ds._leftDepth;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return SubgraphDepthLocater;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return SubgraphDepthLocater;
}();

exports.default = SubgraphDepthLocater;

var DepthSegment =
/*#__PURE__*/
function () {
  function DepthSegment() {
    _classCallCheck(this, DepthSegment);

    DepthSegment.constructor_.apply(this, arguments);
  }

  _createClass(DepthSegment, [{
    key: "compareTo",
    value: function compareTo(obj) {
      var other = obj;
      if (this._upwardSeg.minX() >= other._upwardSeg.maxX()) return 1;
      if (this._upwardSeg.maxX() <= other._upwardSeg.minX()) return -1;

      var orientIndex = this._upwardSeg.orientationIndex(other._upwardSeg);

      if (orientIndex !== 0) return orientIndex;
      orientIndex = -1 * other._upwardSeg.orientationIndex(this._upwardSeg);
      if (orientIndex !== 0) return orientIndex;
      return this._upwardSeg.compareTo(other._upwardSeg);
    }
  }, {
    key: "compareX",
    value: function compareX(seg0, seg1) {
      var compare0 = seg0.p0.compareTo(seg1.p0);
      if (compare0 !== 0) return compare0;
      return seg0.p1.compareTo(seg1.p1);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this._upwardSeg.toString();
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return DepthSegment;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_Comparable.default];
    }
  }]);

  return DepthSegment;
}();

DepthSegment.constructor_ = function () {
  this._upwardSeg = null;
  this._leftDepth = null;
  var seg = arguments[0],
      depth = arguments[1];
  this._upwardSeg = new _LineSegment.default(seg);
  this._leftDepth = depth;
};

SubgraphDepthLocater.DepthSegment = DepthSegment;

SubgraphDepthLocater.constructor_ = function () {
  this._subgraphs = null;
  this._seg = new _LineSegment.default();
  var subgraphs = arguments[0];
  this._subgraphs = subgraphs;
};